/**
 * Used to parse out the link to NoveList from an array of "link" objects.
 *
 * @param {[]} links An array of objects where each object is a "link".
 * @returns {string} A string containing the matched URL if found, otherwise returns null.
 */
export function getLinkToNoveListFromLinks(links){
	if (links) {
		let linkToNoveList = links.find(link => link.label === VIEW_IN_NOVELIST_LABEL);

		return (linkToNoveList ? linkToNoveList.url : null);
	}

	return null;
}

export function getAnchorTargetToNoveListFromLinks(links){
	if (links) {
		let linkToNoveList = links.find(link => link.label === VIEW_IN_NOVELIST_LABEL);

		return (linkToNoveList ? { href: linkToNoveList.url, target: linkToNoveList.target } : null);
	}

	return null;
}

export const VIEW_IN_NOVELIST_LABEL = "View In NoveList";



// WEBPACK FOOTER //
// ./src/lib/LinksUtilities.js